import classNames from "classnames";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  const classes = classNames(className, "w-36 object-fit");
  return (
    <img
      alt="logo"
      src="/assets/logos/logo.png"
      className={classes}
    />
  );
};

export default Logo;
